// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  --BoxGradientBorder-width: 0;
  --BoxGradientBorder-fallbackColor: transparent;
  --BoxGradientBorder-gradient: transparent;
  --BoxGradientBorder-afterZIndex: 0;

  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: -1;

    border-radius: inherit;
    padding: var(--BoxGradientBorder-width);

    border: solid var(--BoxGradientBorder-width) var(--BoxGradientBorder-fallbackColor, transparent);
    z-index: var(--BoxGradientBorder-afterZIndex);
    pointer-events: none;

    @supports ((-webkit-mask-composite: xor) and (-webkit-mask: linear-gradient(#fff 0 0))) {
      background: var(--BoxGradientBorder-gradient, transparent);
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      border: none;
    }
  }
`;

type BoxGradientBorderProps = {
  className?: string;
  children: React.ReactNode;
};

const BoxGradientBorder = ({ className = '', children }: BoxGradientBorderProps) => {
  return <Wrapper className={className}>{children}</Wrapper>;
};

export default BoxGradientBorder;
